import React, { useEffect, useState } from 'react';
import './SnowEffect.css';

const SnowEffect = () => {
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    // Generate snowflakes
    const numberOfSnowflakes = 15;
    const generatedSnowflakes = [];
    
    for (let i = 0; i < numberOfSnowflakes; i++) {
      generatedSnowflakes.push({
        id: i,
        left: Math.random() * 100,
        animationDuration: 3 + Math.random() * 4,
        animationDelay: Math.random() * 5,
        fontSize: 8 + Math.random() * 12,
        opacity: 0.3 + Math.random() * 0.7
      });
    }
    
    setSnowflakes(generatedSnowflakes);
  }, []);

  return (
    <div className="snow-container">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            fontSize: `${flake.fontSize}px`,
            opacity: flake.opacity
          }}
        >
          ❄
        </div>
      ))}
    </div>
  );
};

export default SnowEffect;
